import styled from 'styled-components';

export const Container = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
  font-family: 'Poppins', sans-serif !important;
  .card-1 {
    border-radius: 10px;
  }
  .border-green {
    border: 2px solid #14c585;
    border-radius: 18px;
  }
  .font_16 {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
  }
  .font_17 {
    font-size: 17px;
    color: #000000;
  }
  .hr_renewal_plan {
    width: 302px;
    margin-left: -46px;
    margin-bottom: 30px;
    border: 1px solid #adadad;
  }

  .price {
    font-size: 22px;
  }

  .btn-success {
    background-color: #2a65d7;
    border-color: #2a65d7;
    font-size: 18px;
    border-radius: 50px;
  }
  .title_period {
    border: 2px solid #adadad;
    border-radius: 12px 12px 0 0;
    padding: 10px 30px 0 30px;
    margin-bottom: -15px;
    margin-left: 20px;
    margin-right: 20px;
    height: 59px;
  }
`;
